import { prop, pipe } from 'ramda';

const selectAllCollectionsState = prop('collections');

export const selectCreateCollectionIsLoading = pipe(
  selectAllCollectionsState,
  prop('createCollection'),
  prop<boolean>('isLoading')
);
